var testimonials = {
	selector: '[data-testimonials="element"]',
	progress: false,
	init: function () {
		var self = this;
		var element = document.querySelector(self.selector);

		if (element === null) {
			return;
		}

		var prev = element.querySelector('[data-testimonials="prev"]');
		var next = element.querySelector('[data-testimonials="next"]');

		var sliderElement = element.querySelector('[data-testimonials="slider"]');

		var slider = tns({
			container: sliderElement,
			items: 1,
			controls: false,
			infinite: true,
			rewind: false,
			loop: true,
			nav: false,
			mouseDrag: true,
			gutter: 16,
			preventScrollOnTouch: 'auto',
			speed: 500,
			responsive: {
				768: {
					items: 2,
				},
				1200: {
					items: 3,
				},
			},
		});

		prev.addEventListener('click', () => {
			if ( true === this.progress ) {
				return;
			}

			this.progress = true;
			slider.goTo('prev');

			setTimeout( () => {
				this.progress = false;
			}, 600 );
		});

		next.addEventListener('click', () => {
			if ( true === this.progress ) {
				return;
			}

			this.progress = true;
			slider.goTo('next');

			setTimeout( () => {
				this.progress = false;
			}, 600 );
		});

		const options = { 
            threshold: 0.5,
            rootMargin: '0px'
        }
		
		var observer = new IntersectionObserver((entries, observer) => {
			entries.forEach( ( entry ) => {
				if ( entry.isIntersecting ) {
					slider.goTo('next');
					observer.unobserve( entry.target );
				}
			} );
		}, options);

		observer.observe(element);
	}
};

export { testimonials };
